import React from 'react';
import { useField } from 'formik';
import { usePlacesWidget } from 'react-google-autocomplete';
import classNames from '../../../utility/classNames';
import formatAddress from '../../../utility/formatAddress';

function GooglePlaces({ label, layout = 'default', ...props }) {
  const [field, meta, helpers] = useField(props.name);
  const { value, touched, error } = meta;
  const { setValue } = helpers;
  const googleApiKey = process.env.GOOGLE_MAPS_KEY;

  const { ref } = usePlacesWidget({
    apiKey: googleApiKey + '&callback=Function.prototype',
    onPlaceSelected: (place) => {
      setValue(place.address_components);
    },
    options: {
      types: ['address'],
      fields: ['address_components'],
    },
  });

  return (
    <div className={classNames(layout === 'compact' && 'my-0 space-y-0')}>
      <div
        className={classNames(
          'sm:grid sm:grid-cols-3-inputs text-base sm:items-center sm:gap-2',

          layout === 'compact' && 'sm:gap-4 pt-0 border-none'
        )}
      >
        <label
          htmlFor={field.name}
          className={classNames(
            layout === 'stacked' && 'col-span-3',
            'h-full flex font-normal text-md text-neutral-900',
            touched && error ? 'items-start' : 'items-center'
          )}
        >
          {label}
        </label>
        <div
          className={classNames(
            layout === 'stacked' ? 'col-span-3' : 'col-span-2',
            'relative rounded'
          )}
        >
          <input
            id={field.name}
            onKeyPress={(event) => {
              // Prevent form submission when user selects an address from the dropdown
              if (event.code === 'Enter' || event.code === 'NumpadEnter')
                event.preventDefault();
            }}
            autoComplete="address"
            ref={ref}
            {...field}
            type="text"
            value={formatAddress(value)}
            {...props}
            className={classNames(
              'block w-full border focus:border-primary bg-neutral-input focus:outline-none focus:ring-transparent  text-md  h-8 rounded-md py-0 px-3 placeholder-neutral-500 placeholder-opacity-90',
              meta.touched && meta.error
                ? 'border-warning'
                : 'border-transparent'
            )}
          />
          {touched && error ? (
            <div className="error text-base font-small text-warning	">
              {error === 'Required' ? error : 'Enter correct address'}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default GooglePlaces;
